import React from "react";
import { Navigate } from "react-router-dom";
import configs from "../../config";

import useAuth from "../../hooks/useAuth";

const GuestGuard = ({ children }) => {
   const { isLoggedIn } = useAuth();

   if (isLoggedIn) {
      return <Navigate to={configs.BASE_URL} replace />;
   }

   return <React.Fragment>{children}</React.Fragment>;
};

export default GuestGuard;
